import { smartAxios } from "../axios/Axios";
import { agentEndpoints } from "./agentEndpoints";
import { IPostAIVehicle, IAIVehicleImageResponse } from "./agentModel";

export const postAIVehicleImage = (data: IPostAIVehicle) => {
  return smartAxios.post<IAIVehicleImageResponse>(
    agentEndpoints.postAIVehicleImage,
    data,
    {
      baseURL: "https://agent.halper.ai",
    }
  );
};
